import "./GetInvolved.module.css";
import Header from "@/reusable_sections/Header";
import PathwaysToInvolvement from "./sections/PathwaysToInvolvement";
import InvestInImpact from "./sections/InvestInImpact";
import VolunteerApplication from "./sections/VolunteerApplication";
import Footer from "@/reusable_sections/Footer";
export default function GetInvolvedPage() {
  return <div>
      <Header />
      <PathwaysToInvolvement />
      <InvestInImpact />
      <VolunteerApplication />
      <Footer />
    </div>;
}